import { SVGProps } from 'react'

const MarketingAiIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_9255_41062)">
        <path
          d="M36 23.9983C36 30.6183 30.62 35.9983 24 35.9983C17.38 35.9983 12 30.6183 12 23.9983C12 17.3783 17.38 11.9983 24 11.9983C24.19 11.9983 24.38 11.9983 24.57 12.0083C25.4 12.0483 26.04 12.7483 26 13.5783C25.96 14.4083 25.28 15.0283 24.43 15.0083C24.29 15.0083 24.14 14.9983 24 14.9983C19.04 14.9983 15 19.0383 15 23.9983C15 28.9583 19.04 32.9983 24 32.9983C28.96 32.9983 33 28.9583 33 23.9983C33 23.8583 33 23.7083 32.99 23.5683C32.95 22.7383 33.59 22.0383 34.42 21.9983C35.27 21.9683 35.95 22.5983 35.99 23.4283C35.99 23.6183 36 23.8083 36 23.9983ZM22.91 20.1483C23.71 19.9183 24.17 19.0983 23.95 18.2983C23.73 17.4983 22.89 17.0383 22.1 17.2583C19.1 18.1083 17.01 20.8783 17.01 23.9983C17.01 27.8583 20.15 30.9983 24.01 30.9983C27.13 30.9983 29.9 28.9083 30.75 25.9083C30.98 25.1083 30.51 24.2783 29.71 24.0583C28.91 23.8283 28.08 24.2983 27.86 25.0983C27.38 26.8083 25.79 28.0083 24.01 28.0083C21.8 28.0083 20.01 26.2183 20.01 24.0083C20.01 22.2283 21.21 20.6383 22.92 20.1583L22.91 20.1483ZM22.94 22.9383C22.35 23.5283 22.35 24.4783 22.94 25.0583C23.23 25.3483 23.62 25.4983 24 25.4983C24.38 25.4983 24.77 25.3483 25.06 25.0583L30.12 19.9983H32.5C32.9 19.9983 33.28 19.8383 33.56 19.5583L35.56 17.5583C35.99 17.1283 36.12 16.4883 35.89 15.9283C35.66 15.3683 35.11 14.9983 34.5 14.9983H33V13.4983C33 12.8883 32.63 12.3483 32.07 12.1083C31.51 11.8783 30.86 12.0083 30.44 12.4383L28.44 14.4383C28.16 14.7183 28 15.0983 28 15.4983V17.8783L22.94 22.9383Z"
          fill="#7181FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_9255_41062">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(12 12)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default MarketingAiIcon
